import styled from "@emotion/styled";

export const RowAdderCell = styled.td({
    padding: "10px 5px !important",
});
